/** Resolve primary numeric/string id from common API row shapes. */
export function resolveRowId(row) {
    if (row == null || typeof row !== 'object') return null;
    const raw = row.id ?? row.userId ?? row.user_id ?? row.studentId ?? row.student_id
        ?? row.branchId ?? row.branch_id ?? row.levelId ?? row.level_id
        ?? row.enrollmentId ?? row.enrollment_id ?? row.planId ?? row.discountId
        ?? row.auditId ?? row.audit_id;
    if (raw == null || raw === '') return null;
    const num = Number(raw);
    return Number.isFinite(num) ? num : raw;
}

export function fullName(row) {
    return [row?.firstName, row?.middleName, row?.lastName].filter(Boolean).join(' ').trim()
        || row?.name
        || row?.studentName
        || '';
}

export function compareValues(a, b, direction = 'asc') {
    const mult = direction === 'desc' ? -1 : 1;
    if (a == null && b == null) return 0;
    if (a == null) return 1;
    if (b == null) return -1;

    if (typeof a === 'number' && typeof b === 'number' && !Number.isNaN(a) && !Number.isNaN(b)) {
        return (a - b) * mult;
    }

    if (a instanceof Date && b instanceof Date) {
        return (a.getTime() - b.getTime()) * mult;
    }

    const sa = String(a).toLowerCase();
    const sb = String(b).toLowerCase();
    return sa.localeCompare(sb, undefined, { numeric: true, sensitivity: 'base' }) * mult;
}

/** Normalize column map: { key: getterFn } or { key: { getValue } } */
export function normalizeColumns(columns) {
    const out = {};
    Object.entries(columns || {}).forEach(([key, def]) => {
        if (typeof def === 'function') {
            out[key] = def;
        } else if (def && typeof def.getValue === 'function') {
            out[key] = def.getValue;
        }
    });
    return out;
}

export function sortRows(items, columns, sortKey, sortDir) {
    const getters = normalizeColumns(columns);
    const getValue = getters[sortKey] ?? getters.id ?? ((r) => resolveRowId(r));
    const list = [...(items ?? [])];
    list.sort((a, b) => compareValues(getValue(a), getValue(b), sortDir));
    return list;
}
